module.exports = __webpack_public_path__ + "static/img/badge_vr.6c03964.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/badges/badge_vr.svg
// module id = 2724
// module chunks = 0